import { createHevitonApiV2, type HevitonApiV2 } from '@heviton/heviton-api-v2';
import { useAuthStore } from '@/entities/auth';
import { env } from '@/env';
import type { ApiCallbacks } from './api-callbacks';

/**
 * `HevitonApiV2` factory — v3 옆에 병행 배선되는 데이터 도메인(/api/v2) 클라이언트.
 * v3 와 같은 origin·access token·횡단 콜백을 공유한다.
 *
 * 401 재발급은 composition 의 공통 `reissue`(single-flight, refresh HTTP 는 v3 클라이언트) 를 주입받아
 * 호출한다 — 세 API 가 같은 함수를 공유해 동시 401 시 refresh rotation 중복 호출이 없다.
 */
export function createApiV2(
  callbacks: ApiCallbacks,
  refreshToken: () => Promise<string | null>,
): HevitonApiV2 {
  return createHevitonApiV2({
    baseURL: env.api.v2.baseUrl,
    getAccessToken: () => useAuthStore.getState().accessToken,
    refreshToken,
    ...callbacks,
  });
}
